/**
 * EventPady+ — Onboarding Tour API
 */
import { apiClient } from '@/services/api/client'
import { API_ENDPOINTS } from '@/services/api/endpoints'
import type { OnboardingProgress, TourStepKey } from '@/types'

function unwrap<T>(payload: T | { data: T }): T {
  if (payload && typeof payload === 'object' && 'data' in (payload as object)) {
    return (payload as { data: T }).data
  }
  return payload as T
}

export const onboardingApi = {
  getProgress: async (): Promise<OnboardingProgress> => {
    const { data } = await apiClient.get<OnboardingProgress | { data: OnboardingProgress }>(
      API_ENDPOINTS.AUTH.ONBOARDING.PROGRESS,
    )
    return unwrap(data)
  },

  completeStep: async (step: TourStepKey): Promise<OnboardingProgress> => {
    const { data } = await apiClient.post<OnboardingProgress | { data: OnboardingProgress }>(
      API_ENDPOINTS.AUTH.ONBOARDING.COMPLETE_STEP,
      { step },
    )
    return unwrap(data)
  },

  dismiss: async (): Promise<void> => {
    await apiClient.post(API_ENDPOINTS.AUTH.ONBOARDING.DISMISS)
  },
}
